import React from "react";
import {
  Drawer,
  Box,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { WSIcons } from "../../commonFunctions/iIcons";

interface OrderDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const ChargesInformation: React.FC<OrderDrawerProps> = ({
  open,
  onClose,
}) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: "60rem",
          padding: "2rem",
          bgcolor: "#f9f9f9",
          boxShadow: 3,
        },
      }}
    >
      <Grid container direction="column" spacing={3}>
        {/* Header with Close Button */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Typography variant="h5" fontWeight="bold" color="green">
            Charges Information
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: "red" }} />
          </IconButton>
        </Grid>

        {/* Amount Summary Boxes */}
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {[
            { label: "Total", value: "0.00", color: "green" },
            { label: "Settled", value: "0.00", color: "black" },
            { label: "Due", value: "0.00", color: "red" },
          ].map((item, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Grid
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "6rem",
                  borderRadius: "8px",
                  boxShadow: 2,
                  padding: 2,
                  bgcolor: "white",
                  border: `1px solid ${item.color}`,
                }}
              >
                <Typography variant="h5" color={item.color}>
                  {item.value}
                </Typography>
                <Typography variant="subtitle1">{item.label}</Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>

        {/* Charge Details */}
        {[
          { label: "Amount", value: "0.00" },
          { label: "Item Dis.", value: "0.00" },
          { label: "Tax", value: "0.00" },
          { label: "Bill Dis.", value: "0.00" },
          { label: "Round Off", value: "0" },
          { label: "Gratuity", value: "0.00" },
        ].map((item, index) => (
          <Grid
            key={index}
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{
              padding: "0.5rem 1rem",
              marginY: "0.5rem",
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: 1,
              border: "1px solid #ccc",
            }}
          >
            <Grid item xs={6} sm={4}>
              <Typography variant="subtitle1">{item.label}</Typography>
            </Grid>
            <Grid item xs={6} sm={4} textAlign="right">
              <Typography variant="subtitle1">{item.value}</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Drawer>
  );
};
